import React, {useContext} from "react";
import apiService from "../../../api/apiService";
import {useQuery} from "react-query";
import Loading from "../Loading";
import styled from "styled-components";
import EnvResultsTable from "./envResultsTable/EnvResultsTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCirclePlus} from "@fortawesome/pro-light-svg-icons";
import {useNavigate} from "react-router-dom";
import {blueprintCategory, cpx, demoEnv, userDetails} from "../../../utils/const/query-key";
import AdminIcon from "../../assets/moreToolsAssets/AdminIcon";
import ContactUsIcon from "../../assets/moreToolsAssets/ContactUsIcon";
import LearnMoreIcon from "../../assets/moreToolsAssets/LearnMoreIcon";
import ModalContext from "./envResultsTable/ModalContext";
import BasicModal from "./BasicModal";
import SalesForceFailedModal from "./SalesForceFailedModal";
import DeleteEnvModal from "./DeleteEnvModal";

const Header = styled.div`
  font-size: 30px;
  margin: 0px 0;
`;
const ButtonContainer = styled.div`
  text-align: right;
`;

const CreateEnvButton = styled.button`
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  color: var(--color-brand-pink-primary);
  border: none;
  background-color: transparent;
`;

const ToolsButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
`;

const ToolButton = styled.div`
  padding-right: 5px;
  cursor: pointer;
  display: flex;
`;

const IconStyle = styled.span`
  display: flex;
  width: 25px;
  padding-bottom: 5px;
  padding-right: 5px;
  align-items: end;
`

const A = styled.a`
  text-decoration: none;
  color: black;
  display: flex;
`;

const IconLabelStyle = styled.div`
  font-size: 15px;
  display: flex;

  .divider {
    color: #cccccc;
    padding-left: 5px;
  }
`

const DemoPointEnv = () => {
    const navigate = useNavigate();
    const {status: demoEnvStatus} = useQuery(demoEnv, () =>
        apiService.getEnvironmentData()
    );
    const {data: userData} = useQuery(userDetails, () => apiService.getUser(), {staleTime: Infinity});
    const {data: isCpx} = useQuery(cpx, () => apiService.getIsCpx());

    const {basicModalIsOpen, failedSalesForceModalIsOpen, deleteEnvModalIsOpen} = useContext(ModalContext);


    if (demoEnvStatus === "loading") {
        return <Loading/>;
    }

    if (demoEnvStatus === "error") {
        return <h1>error</h1>;
    }

    const navigateToAdminPage = () => {
      if(userData?.isAdmin){
        navigate("/admin");
      } else if(userData?.isTechPointAdminReports){
        navigate("/admin/reports");
      }
    }

    return (

        <>
            <Header>
                <ToolsButtonsContainer>
                    {(userData?.isAdmin || userData?.isTechPointAdminReports) &&
                        <ToolButton
                            id={"admin_button"}
                            onClick={ navigateToAdminPage }>
                            <IconStyle>
                                <AdminIcon/>
                            </IconStyle>
                            <IconLabelStyle>
                                <div>Admin</div>
                                <div className={"divider"}>|</div>
                            </IconLabelStyle>
                        </ToolButton>
                    }
                    <ToolButton>
                        <A id={"contact_button"} href="mailto:sc@checkpoint.com" title="Contact Us">
                            <IconStyle>
                                <ContactUsIcon/>
                            </IconStyle>
                            <IconLabelStyle>
                                <div>Contact</div>
                                <div className={"divider"}>|</div>
                            </IconLabelStyle>
                        </A>
                    </ToolButton>
                    <ToolButton>
                        <A id={"learn_more_button"}
                           href="https://supportcenter.checkpoint.com/supportcenter/portal?eventSubmit_doGoviewsolutiondetails=&solutionid=sk119392&source=TechPoint"
                           title="Learn More"
                           target="_blank">
                            <IconStyle>
                                <LearnMoreIcon/>
                            </IconStyle>
                            <IconLabelStyle>
                                <div>Learn More</div>
                            </IconLabelStyle>
                        </A>
                    </ToolButton>
                </ToolsButtonsContainer>
                <div>My DemoPoint Environments</div>
                <ToolsButtonsContainer>
                    {(userData?.isCpSales || userData?.isUserCenterPartner) &&
                        <ButtonContainer id="newEnvButton">
                            <CreateEnvButton id={"create_env_button"} onClick={() => navigate("/demo-point/createEnv")}>
                                <FontAwesomeIcon icon={faCirclePlus}/> Create Environment
                            </CreateEnvButton>
                        </ButtonContainer>
                    }
                    {isCpx ==='true'  &&
                        <ButtonContainer id="newEnvButtonCPX">
                            <CreateEnvButton id={"create_env_button_cpx"}
                                             onClick={() => navigate("/demo-point/createEnvCPX")}>
                                <FontAwesomeIcon icon={faCirclePlus}/> Create Environment CPX
                            </CreateEnvButton>
                        </ButtonContainer>
                    }
                </ToolsButtonsContainer>
            </Header>
            {basicModalIsOpen && <BasicModal id={"basic_modal"}/>}
            {failedSalesForceModalIsOpen && <SalesForceFailedModal id={"salesforce_failed_modal"}/>}
            {deleteEnvModalIsOpen && <DeleteEnvModal id={"delete-env-modal"}/>}
            <EnvResultsTable/>
        </>
    );
};

export default DemoPointEnv;
